import React, { InputHTMLAttributes, forwardRef, useId, useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  requiredLabel?: boolean;
  error?: string;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, requiredLabel, error, type = 'text', className = '', ...props }, ref) => {
    const [showPassword, setShowPassword] = useState(false);
    const isPassword = type === 'password';
    // ラベルと入力欄を関連付ける（ラベルのクリックや読み上げに対応）。
    const autoId = useId();
    const inputId = props.id || autoId;

    return (
      <div className="mb-6">
        <label htmlFor={inputId} className="block text-sm font-bold text-slate-700 mb-2 flex items-center">
          {requiredLabel && (
            <span className="text-[10px] text-red-500 bg-red-50 px-1.5 py-0.5 rounded-[4px] border border-red-100 mr-2">必須</span>
          )}
          <span>{label}</span>
        </label>
        <div className="relative">
          <input
            ref={ref}
            type={isPassword ? (showPassword ? 'text' : 'password') : type}
            className={`w-full bg-white border border-gray-300 rounded-[4px] py-3 px-4 text-slate-700 placeholder-gray-400 text-sm transition-all duration-200 outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-100 ${
              error ? 'border-red-400' : ''
            } ${className}`}
            {...props}
            id={inputId}
          />
          {isPassword && (
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              aria-label={showPassword ? 'パスワードを隠す' : 'パスワードを表示'}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
            >
              {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          )}
        </div>
        {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
      </div>
    );
  }
);

Input.displayName = 'Input';

export default Input;